export default "__VITE_ASSET__BAUqkNqN__"